import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./redesign/tokens.css";
// Mobile enhancement layer. Every rule inside is scoped to (max-width:767px)
// so desktop rendering is unaffected. See styles/mobile.css for the contract.
import "./styles/mobile.css";
import { installRedesignClass } from "./redesign/flag";

// Phase 6 — apply .redesign class on <html> if VITE_REDESIGN=1 or ?redesign=1.
// No-op when the flag is off; legacy CSS is unaffected.
installRedesignClass();

// Expose X Pixel ID to the index.html snippet so twq('config', ...) fires.
// When VITE_X_PIXEL_ID is unset (before Pixel is created in Events Manager)
// the base snippet no-ops safely.
const xPixelId = import.meta.env.VITE_X_PIXEL_ID as string | undefined;
if (xPixelId && typeof window !== "undefined") {
  (window as unknown as { __X_PIXEL_ID__?: string }).__X_PIXEL_ID__ =
    xPixelId;
  // Re-trigger config in case the base snippet ran before this executes.
  const w = window as unknown as { twq?: (...args: unknown[]) => void };
  if (w.twq) w.twq("config", xPixelId);
}

createRoot(document.getElementById("root")!).render(<App />);
